var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoListOv1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 158,
    viewBox: "0 0 155 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4919 11.6535L77.9 8.27147C81.3392 7.02653 84.1258 5.71627 87.8807 5.96847C99.2085 6.7635 112.895 22.4316 120.028 30.5434C120.888 31.5364 122.172 32.8583 123.213 33.66L129.359 41.7189C129.915 42.5152 130.606 43.2415 131.149 44.0651C145.162 64.9919 149.396 88.3942 136.032 110.973C119.076 139.649 83.2712 146.993 55.2643 130.983C41.749 123.258 25.6514 104.722 15.6729 92.4937C8.49067 83.6626 0.955042 72.6753 10.2855 62.2979C19.6124 51.9393 32.1239 53.79 41.6257 62.3907C52.2202 71.995 61.0687 84.8849 72.1356 93.8684C82.5073 102.301 100.576 100.042 104.613 85.7713C108.632 71.5664 87.935 53.994 79.7987 43.7088C72.8359 34.9165 63.1492 21.7408 73.4923 11.6537L73.4919 11.6535Z",
    fill: "#F9B634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.588 112.485C120.727 142.69 83.0677 150.297 53.7905 133.561C46.6657 129.489 39.0308 122.682 32.0182 115.502C24.9682 108.282 18.3854 100.515 13.3723 94.3714L13.3686 94.3677C9.78468 89.9609 5.75813 84.6136 3.95411 78.8646C3.03466 75.9345 2.66069 72.8108 3.26291 69.6039C3.86811 66.3814 5.42368 63.2634 8.07721 60.3121L8.07889 60.3107C13.2925 54.5205 19.5901 51.9832 26.0213 52.2682C32.3563 52.549 38.4907 55.5476 43.6185 60.1891L43.6199 60.1907C49.066 65.1279 54.053 70.8998 58.9248 76.3916C63.8511 81.9449 68.6849 87.2423 74.0069 91.5625L74.0092 91.5646C78.4678 95.1895 84.6608 96.5501 90.1536 95.4248C95.5614 94.3168 100.086 90.8677 101.756 84.963L101.755 84.9626C102.525 82.2425 102.169 79.1768 100.814 75.7433C99.4544 72.3003 97.1715 68.6991 94.4033 65.0718C91.6443 61.4566 88.4967 57.9348 85.4784 54.6228C82.507 51.3624 79.588 48.2286 77.471 45.5527C74.0187 41.1933 69.5431 35.3408 67.3564 29.1567C66.2473 26.0198 65.6652 22.6394 66.2009 19.2217C66.5508 16.9895 67.3666 14.8329 68.7054 12.7947L67.7013 12.3538L71.6842 9.2979L76.0919 5.9156L76.4571 5.63545L76.8892 5.47965C80.0345 4.34109 83.5444 2.70109 88.0794 3.00561L88.0886 3.00646C94.8208 3.47896 101.728 8.22507 107.486 13.2805C113.383 18.4576 118.71 24.5481 122.258 28.5827L122.265 28.5911L122.273 28.5999C123.077 29.5283 124.21 30.6805 125.024 31.3067L125.336 31.5461L125.575 31.859L131.72 39.9184L131.759 39.9685L131.795 40.0205C131.999 40.3134 132.234 40.6015 132.569 41.0164C132.873 41.3926 133.259 41.875 133.615 42.4134L133.616 42.4125C148.064 63.9901 152.696 88.6466 138.588 112.485Z",
    stroke: "white",
    strokeWidth: 5.93911
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_20",
    x: 0,
    y: 0,
    width: 154.535,
    height: 157.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.45433,
    dy: 11.8782
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_20",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoListOv1);
export default __webpack_public_path__ + "static/media/info-list-ov-1.a902ebe7b627050a494a0a0c6bb94b3e.svg";
export { ForwardRef as ReactComponent };